import React from "react";

import { FastEntryInputSizes } from "../../../enums";
import { KeyName } from "../../../keyName";
import TestIds from "../../../testIds";
import { IInputProps, ISharedInputProps } from "../input";
import { StyledTokenInput, StyledTokenInputWrapper } from "./TokenInput.styles";

interface IProps extends IInputProps, ISharedInputProps {
    color: string;
}

interface IState {
    width: FastEntryInputSizes;
}

export default class TokenInput extends React.Component<IProps, IState> {
    private inputRef: React.RefObject<HTMLInputElement> = React.createRef();

    handleClick = (): void => {
        this.inputRef.current?.focus();
    };

    handleOnChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        this.props?.onChange({
            value: e.target.value,
            origEvent: e
        });
    };

    handleKeyDown = (e: React.KeyboardEvent): void => {
        switch (e.key) {
            case KeyName.Enter:
                this.inputRef.current?.blur();
                break;
        }
    };

    render = () => {
        return (
            <StyledTokenInputWrapper
                data-testid={TestIds.TokenInput}
                onClick={this.handleClick}
                _cursor={this.props.cursor}
                _width={this.props.width}
                $isDisabled={this.props.isDisabled}
                auditTrailType={this.props.auditTrailData?.type}
                _height={this.props.height}>
                <StyledTokenInput
                    $color={this.props.color}
                    $isDisabled={this.props.isDisabled}
                    $value={this.props.value} data-value={this.props.value}>
                    <input
                        ref={this.inputRef}
                        type={"text"}
                        disabled={this.props.isDisabled}
                        onChange={this.handleOnChange}
                        onKeyDown={this.handleKeyDown}
                        value={this.props.value}/>
                </StyledTokenInput>
            </StyledTokenInputWrapper>
        );
    };
}